import React from 'react';
import './index.scss';

export function InputHelperText({ children }) {
  return <div className="c-payment-journey-input-helper-text">{children}</div>;
}
